import { UserProfile } from 'src/types/AzarUser';
import { InventoryItem } from 'src/types/itemInventory';
import { PeerProfile } from 'src/types/Match';

export const getUserGemsAmount = (inventoryItems?: InventoryItem[]) =>
  inventoryItems?.find((item) => item.itemId === 'ITEM_ID_GEM')?.quantity;

export const getFlagIconUrlFromProfile = (profile: UserProfile | PeerProfile) => {
  return `/images/flags/icFlag${profile.location?.countryCode || profile.country}.png`;
};
